import React, {useState, useEffect, useCallback} from 'react';
import api from '../contexts/BaseUrl'
import './Home.css'
import LeftPanel from '../components/LeftPanel';
import Loading from '../components/Loading';
import { useContext } from "react";
import { UnitShadeContext } from "../contexts/UnitShadeContext";

export default function Home(){

    const { unitShadeNo } = useContext(UnitShadeContext)
    const token = JSON.parse(localStorage.getItem('auth')).token;
    const [isLoading,setIsLoading] = useState(false);
    const [expenseData,setExpenseData] = useState([]);


    const fetchHomeData = useCallback( async () =>{
        setIsLoading(true);
        await api.get(`expenses/total-expenses-by-type?unitShadeId=${unitShadeNo}`,{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setExpenseData(response.data);
            setIsLoading(false);
        }).catch(err =>{
            setIsLoading(false);
        })
    },[token,unitShadeNo])

    useEffect(() =>{
        fetchHomeData();
    },[fetchHomeData])

    return(
        <div className='homePage'>
            <LeftPanel
                tabName='home'
            />
            <div id='rightPanel'>
                <div id='rightPanelContent'>
                    {isLoading ? 
                    <div style={{marginTop:'100px'}}>
                        <Loading /> 
                    </div>
                    :
                    <div id='boxContent'>
                        {expenseData.map(item => (
                            <div id='boxItem'>
                                <div id='header'>{item.expenseTypeName} Expenses</div>
                                <div id='headerContent'>Tk {item.totalAmount}</div>
                            </div>
                        ))}
                    </div>
                    
                    }
                
                    
                </div>
            </div>
        </div>
    )
}